import LabellingFlow from './LabellingFlow';
export default LabellingFlow;
